import { Deserializer } from "jsonapi-serializer";
import { Discovery, DiscoveryWrapper } from "../models/Discovery";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { getConstraintViolation, processServerError } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getDiscoveries = async (listParameters?: ListQuery): Promise<DiscoveryWrapper> => {
    try {
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm)
        const partialURL = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `discovery?include=unitType${partialURL}`;

        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({ status: response.status, message: genericError });
                }

                const discoveries: Discovery[] = data.map((discovery): Discovery => {
                    return {
                        id: discovery['id'],
                        name: discovery['host-name'],
                        fixedAddress: discovery['fixed-address'],
                        ipAddress: discovery['ip-address'],
                        status: discovery['installed'],
                        nameOriginal: discovery['host-name'], // This used for showing summary since name is includes an icon
                        macAddress: discovery['mac-address'],
                        unitTypeId: discovery['unit-type']?.["id"] ?? 0,
                        unitTypeName: discovery['unit-type']?.["trn-name"] ?? ""
                    }
                })

                return resolve({ rows: discoveries, pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
